import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import DeleteCard from "../../../Components/Cards/DeleteCard/DeleteCard";
import Role_Form from "../../../Components/Forms/Role/Role_Form";
import { useSearch } from "../../../context/SearchContext";
import api from "../../../utils/api";
import "./AddRole.css";

const AddRole = () => {
  const { search } = useSearch();
  const [data, setData] = useState([]);
  const [isModal, setIsModal] = useState(0);
  const [id, setId] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [viewData, setViewData] = useState({});
  const [editData, setEditData] = useState({});
  const [isCreate, setIsCreate] = useState(false);
  const [loading, setLoading] = useState(false);

  const permissionOptions = [
    { id: "dashboard", name: "Dashboard" },
    { id: "aboutus", name: "About Us" },
    { id: "advertisement", name: "Advertisement" },
    { id: "circular", name: "Circular" },
    { id: "application", name: "Application" },
    { id: "student", name: "Students" },
    { id: "existing_student", name: "Existing Student" },
    { id: "teacher", name: "Teacher" },
    { id: "fee", name: "Fees" },
    { id: "new_admission", name: "New Admission" },
    { id: "role", name: "Role" },
  ];

  // Pagination state
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/role?page=${pagination.page}&limit=${pagination.limit}&search=${search}`);
      setData(res.data.data || []);
      setPagination((prev) => ({
        ...prev,
        total: res.data.pagination.total,
        totalPages: res.data.pagination.totalPages,
      }));
    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch roles");
    } finally {
      setLoading(false);
    }
  };

  // Fetch roles on component mount and when pagination/search changes
  useEffect(() => {
    fetchRoles();
  }, [pagination.page, pagination.limit, search]);

  // Handle page change
  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  // Handle limit change
  const handleLimitChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      limit: Number(e.target.value),
      page: 1,
    }));
  };

  const handleEditSave = async (updatedData) => {
    try {
      await api.put(`/role/${updatedData.id}`, updatedData);
      toast.success("Role updated successfully!");
      setIsEdit(false);
      fetchRoles(); // Refresh the list
    } catch (err) {
      console.log(err);
      toast.error("Failed to update role");
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/role/${id}`);
      toast.success("Role deleted successfully!");
      setIsModal(0);
      fetchRoles(); // Refresh the list
    } catch (err) {
      console.log(err);
      toast.error("Failed to delete role");
    }
  };

  const handleCreate = async (newRole) => {
    try {
      await api.post("/role", newRole);
      toast.success("Role created successfully!");
      setIsCreate(false);
      fetchRoles(); // Refresh the list
    } catch (err) {
      console.log(err);
      toast.error("Failed to create role");
    }
  };

  const handleView = (role) => {
    setViewData(role);
    setIsView(true);
    setIsModal(0);
  };

  return (
    <div className="role">
      <div className="role__top">
        <div className="role__top_button">
          <button type="button" className="role__top_button_circular" onClick={() => setIsCreate(true)}>
            Add Role
          </button>
        </div>
      </div>
      {isModal === 1 ? <DeleteCard btn="DELETE" del={handleDelete} msg="Are you sure you want to delete this role?" close={() => setIsModal(0)} /> : null}
      {isEdit && <Role_Form onClose={() => setIsEdit(false)} onSubmit={handleEditSave} isEdit={isEdit} isView={false} data={editData} fetchRoles={fetchRoles} />}
      {isCreate && <Role_Form onClose={() => setIsCreate(false)} onSubmit={handleCreate} isEdit={false} isView={false} data={{}} fetchRoles={fetchRoles} />}
      {isView && <Role_Form onClose={() => setIsView(false)} onSubmit={() => {}} isEdit={false} isView={true} data={viewData} fetchRoles={fetchRoles} />}
      <div className="role__middle">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
        ) : (
          <table>
            <thead>
              <tr className="role__middle_tr">
                <th className="role__middle_th">Role Name</th>
                <th className="role__middle_th">Permissions</th>
                <th className="role__middle_th">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((role) => (
                <tr className="role__middle_tr" key={role.id}>
                  <td className="role__middle_td">{role.name?.toUpperCase() || "-"}</td>
                  <td className="role__middle_td">
                    {role.permissions.map((permission) => {
                      const findPermission = permissionOptions.find((option) => option.id === permission);
                      return <div key={permission}>{findPermission?.name}</div>;
                    })}
                  </td>
                  <td className="role__middle_td role__middle_actions">
                    <button
                      type="button"
                      className="role__middle_td_edit"
                      onClick={() => {
                        setIsEdit(true);
                        setEditData(role);
                        setIsModal(0);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      className="role__middle_td_delete"
                      onClick={() => {
                        setId(role.id);
                        setIsModal(1);
                      }}
                    >
                      Delete
                    </button>
                    <button type="button" className="role__middle_td_view" onClick={() => handleView(role)}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === pagination.totalPages ? "not-allowed" : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={handleLimitChange}
            style={{
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "rgb(239,239,239)",
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default AddRole;
